import { Button } from "react-bootstrap";
import { Task } from "../interfaces/Task";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import parse from 'html-react-parser';
import { Overlay } from "../elements/Overlay";

interface DeleteTaskProps {
    task: Task,
    deleteCallback: CallableFunction;
    closeCallback: CallableFunction;
}


export default function DeleteTask(props: DeleteTaskProps) {
    const { t } = useTranslation();
    
    const navigate = useNavigate();
    const handleDelete = () => {
        const requestOptions = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/task/' + props.task._id, requestOptions)
            .then(response => {
                props.deleteCallback();
            })
            .catch(error => {
                navigate('/');
            });
    }

    const handleClose = () => {
        props.closeCallback();
    }

    return (
        <Overlay title={t("Delete task")} onClose={handleClose} className="delete-task-container confirmation-dialog">
            <p>
                { parse(t("You are about to delete the task") + ' ' + '<strong>' + props.task.name + '</strong>. ' + t("This action cannot be undone.")) }
            </p>
            <div className="actions">
                <Button className="btn btn-primary" onClick={ handleDelete }>{ t("Delete") }</Button>
                <Button className="btn btn-warning" onClick={ handleClose }>{ t("Cancel") }</Button>
            </div>
        </Overlay>
    );
}